export const disabledRoutes = new Set(
  process.env.NEXT_PUBLIC_DISABLED_ROUTES?.split(",") ?? []
);
